"use client";

import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AddressCopyProps {
  label: string;
  address: string;
}

export function AddressCopy({ label, address }: AddressCopyProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Ignore copy errors
    }
  };

  return (
    <div className="flex flex-col gap-1 rounded-lg border border-border bg-card p-3">
      <span className="font-pixel text-[10px] text-primary">{label}</span>
      <div className="flex items-center gap-2">
        <code className="flex-1 truncate font-mono text-sm text-foreground">{address}</code>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 shrink-0"
          onClick={handleCopy}
          aria-label="Copy address"
        >
          {copied ? (
            <Check size={14} className="text-[var(--accent-green)]" />
          ) : (
            <Copy size={14} />
          )}
        </Button>
      </div>
    </div>
  );
}
